<!-- emulator -->
<div style="display: flex; justify-content: space-around; align-items: center; padding: 0 31px; height: 100vh">
  <div
    class="mobile-wrapper"
    style="
      border-radius: 11px;
      border: 2.5px solid #c8c8c8;
      width: 800px;
      max-width: 60%;
      border-left: 0;
      border-right: 0;
      background-color: #eaf0f6;
    "
  >
    <div class="mobile" style="border-radius: 7px; padding-bottom: calc(100vh - 310px); background-color: #eaf0f6">
      <div
        style="
          display: flex;
          padding-top: 0.5rem;
          padding-left: 0.5rem;
          border-bottom: 2.5px solid #c8c8c8;
          padding-bottom: 0.25rem;
          border-radius: 7px;
          background-color: white;
        "
      >
        <div
          style="
            content: '';
            width: 12px;
            padding-bottom: 12px;
            border-radius: 50%;
            background: #e9e9e9;
            border: #e9e9e9;
            display: block;
            margin-left: 10px;
          "
        ></div>

        <div
          style="
            content: '';
            width: 12px;
            padding-bottom: 12px;
            border-radius: 50%;
            background: #e9e9e9;
            border: #e9e9e9;
            display: block;
            margin-left: 10px;
          "
        ></div>

        <div
          style="
            content: '';
            width: 12px;
            padding-bottom: 12px;
            border-radius: 50%;
            background: #e9e9e9;
            border: #e9e9e9;
            display: block;
            margin-left: 10px;
          "
        ></div>
      </div>
      <div
        id="header"
        class="header"
        style="
          background-color: #e9e9e9;
          padding-left: 10px;
          padding-right: 10px;
          padding-bottom: 5px;
          display: grid;
          transform: none !important;
        "
      >
        <div class="navbar" style="display: block">
          <p style="margin: 4px 0">To: receiver&#64;email.com</p>
          <p style="margin: 4px 0">From: sender&#64;email.com</p>
          <p style="margin: 4px 0">Subject:</p>
        </div>
      </div>

      <div class="screen" style="height: 70%; margin-top: 4rem">
        <editor
          [apiKey]="editorApiKey"
          [cloudChannel]="'8'"
          [init]="editorConfig"
          style="border: none"
          [(ngModel)]="html"
          [ngModelOptions]="{ standalone: true }"
          [disabled]="true"
          class="content disabled noselect"
        >
        </editor>

        <div class="footer">
          <hr />
        </div>
      </div>
    </div>
  </div>

  <!-- mobile -->
  <div class="mobile-wrapper" style="max-width: 37%">
    <div class="mobile" style="border-top: 9px">
      <div class="photo"></div>

      <div
        class="screen"
        style="border: 3px solid #c8c8c8; padding-left: 0px; margin-left: 0.125rem; background-color: #eaf0f6"
      >
        <div id="os-header" class="os-header">
          <div class="notch-left">
            <i class="fad fa-signal-4"></i>
            <i class="fad fa-flask-potion"></i>
          </div>

          <div class="notch-right">
            <i class="far fa-battery-half"></i>
            <span id="time" class="hour"></span>
          </div>
        </div>
        <div id="header" class="header">
          <div class="navbar" style="display: block">
            <p style="margin: 4px 0">To: receiver&#64;email.com</p>
            <p style="margin: 4px 0">From: sender&#64;email.com</p>
            <p style="margin: 4px 0">Subject:</p>
          </div>
        </div>

        <editor
          [apiKey]="editorApiKey"
          [cloudChannel]="'8'"
          [init]="editorConfig"
          style="border: none; background-color: #fff"
          [(ngModel)]="html"
          [ngModelOptions]="{ standalone: true }"
          [disabled]="true"
          class="disabled noselect mobile-content"
        >
        </editor>

        <div class="footer">
          <hr />
        </div>
      </div>
    </div>
  </div>
  <!-- end mobile -->
</div>
<!-- end emulator -->
